import { RouteObject } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HomePage from "@/pages/home/page";
import ListingPage from "@/pages/listing/page";
import ArticlePage from "@/pages/article/page";
import AProposPage from "@/pages/apropos/page";
import AdminPage from "@/pages/admin/page";
import RecherchePage from "@/pages/recherche/page";
import OpportunitesPage from "@/pages/opportunites/page";
import FormationsPage from "@/pages/formations/page";
import InterviewsPage from "@/pages/interviews/page";
import MentionsLegalesPage from "@/pages/mentions-legales/page";
import NotFound from "@/pages/NotFound";

function HomeLayout() {
  return (
    <div className="min-h-screen bg-[#fdf8f3]">
      <Navbar />
      <HomePage />
      <Footer />
    </div>
  );
}

const routes: RouteObject[] = [
  { path: "/", element: <HomeLayout /> },
  { path: "/success-stories", element: <ListingPage /> },
  { path: "/startups", element: <ListingPage /> },
  { path: "/innovations", element: <ListingPage /> },
  { path: "/femmes-entrepreneures", element: <ListingPage /> },
  { path: "/jeunes-talents", element: <ListingPage /> },
  { path: "/diaspora-africaine", element: <ListingPage /> },
  { path: "/article/:id", element: <ArticlePage /> },
  { path: "/a-propos", element: <AProposPage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "/recherche", element: <RecherchePage /> },
  { path: "/opportunites", element: <OpportunitesPage /> },
  { path: "/formations", element: <FormationsPage /> },
  { path: "/interviews", element: <InterviewsPage /> },
  { path: "/mentions-legales", element: <MentionsLegalesPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
